/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, createContext, useState, ReactChild, useContext } from 'react';
interface DiagnosisContext {
  diagnosis?: any;
  setDiagnosis?: any;
  isAfterPaid?: any;
  setIsAfterPaid?: any;
  diagnosisTrigger?: any;
  setDiagnosisTrigger?: any;
  showModal?: any;
  setShowModal?: any;
}

const context = createContext<DiagnosisContext>({});

const { Provider } = context;

interface Props {
  children: ReactChild | ReactChild[];
}

export const DiagnosisProvider: FC<Props> = ({ children }) => {
  const [diagnosis, setDiagnosis] = useState<any>();
  const [isAfterPaid, setIsAfterPaid] = useState<number>(0);
  const [diagnosisTrigger, setDiagnosisTrigger] = useState<boolean>();
  const [showModal, setShowModal] = useState<boolean>(false);

  return (
    <Provider
      value={{
        diagnosis,
        setDiagnosis,
        isAfterPaid,
        setIsAfterPaid,
        diagnosisTrigger,
        setDiagnosisTrigger,
        showModal,
        setShowModal
      }}>
      {children}
    </Provider>
  );
};

export const useDiagnosis = () => useContext(context);
